import { Component, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { FirebaseService } from '../../service/firebase.service';
import { SharedService } from '../../services/shared.service';
import { langStats } from './data';
import { users } from './data';
import { Device, DataForCharts} from './statistics.model'
import { StatisticsService } from './statistics.service';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {
  single: any[];
  multi: any[];

  devicesForCharts:DataForCharts[] = []
  
  devices: Device[]; //= users[0].groups[0].devices;
  devicesStatus: Array<{ deviceId: string; borneName: string; configName: string }>

  selectedDevice:Device;

  sessionStat: any;

  view: any[] = [700, 400];

  today: Date = new Date(null);// = Date.now();

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;

  showXAxisLabel = true;
  xAxisLabel = "Nom de l'appareil";
  showYAxisLabel = true;
  yAxisLabel = 'Sessions utilisateurs';

  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'right';

  colorScheme = {
    domain: ['#122B47', '#3A5DE5', '#EE2E4F', '#FCBF00']
  };


  constructor(
    private router: Router, private firebaseService: FirebaseService, public _sharedVar: SharedService, public statService: StatisticsService
  ) {
    Object.assign(this, { users }),
      Object.assign(this, { langStats })


    this.router.events.subscribe((e: any) => {

      console.log(e.routerEvent)

        if (e.routerEvent && e.routerEvent.urlAfterRedirects == "/statistics/global") {
          this.initData();
        }
      


      // this.initData();
    })
   }

  ngOnInit(): void {
    this.initData();
   
  }

  initData() {
    // remplacer la clé 'sessions' par 'value' pour ngx-charts
    this.firebaseService.getDeviceStatFromUser().then(d => {
      this.statService.deviceArray.next(d.docs.map(v => v.data()));
      this.devices = d.docs.map(v => v.data());
      for (let i: number = 0; i < this.devices.length; i++) {
        this.devicesForCharts.push({
          name: this.devices[i].name,
          value: this.devices[i].sessions
        })
      }

      this.sessionStat = JSON.parse(JSON.stringify(this.devicesForCharts));
      this.setLastUpdateDate();
    })



  }


  setLastUpdateDate() {
    this.devices.forEach(item => {
      let tmpDate = item.latestSession as any;
      if (tmpDate.toDate() > this.today)
        this.today = tmpDate.toDate()
    })
  }
  refreshStats() {
    this.initData();
  }


  onSelect(data): void {
   // console.log(data);
   // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
   // console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
   // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }


  changeSelectedDevice(deviceName: string) {
    console.log("CAHNGE DEVICD")
    let _devices: Device[]
    _devices = this.devices.filter(
      device => device.name == deviceName
    )
    this.selectedDevice = _devices[0]

    // remplacer la clé 'sessions' par 'value' pour ngx-charts

    if(deviceName == 'global'){

      this.selectedDevice = null
          
      this.router.navigateByUrl('/statistics/global')
      this.firebaseService.getDeviceStatFromUser().then(d => {
        this.statService.deviceArray.next(d.docs.map(v => v.data()));
        this.devices = d.docs.map(v => v.data());
      })
    }
    
    else {
      this.router.navigateByUrl('/statistics/device/' + deviceName)
    }
    
    

  }

}
